module.exports = __webpack_public_path__ + "static/media/letspark-logo.b2f640a7.png";